import React, {
    createContext,
    ReactNode,
    useContext,
    useMemo,
    useState,
} from "react";

import { CoachInfoModalContextValues } from "../types/contexts";
import { IGameTeam } from "../../../../types/api";

const CoachInfoModalContext = createContext<CoachInfoModalContextValues | null>(
    null,
);

export const useCoachInfoModalContext = () => {
    const context = useContext(CoachInfoModalContext);
    if (!context) {
        throw new Error(
            "useCoachInfoModalContext must be used within a CoachInfoModalProvider",
        );
    }
    return context;
};

export const CoachInfoModalProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [showCoachInfoModal, setShowCoachInfoModal] =
        useState<boolean>(false);
    const [team, setTeam] = useState<IGameTeam>();

    const contextValue = useMemo(
        () => ({
            showCoachInfoModal,
            setShowCoachInfoModal,
            team,
            setTeam,
        }),
        [showCoachInfoModal, team],
    );

    return (
        <CoachInfoModalContext.Provider value={contextValue}>
            {children}
        </CoachInfoModalContext.Provider>
    );
};
